import { render, staticRenderFns } from "./ScheduleFamilyManagementConference.vue?vue&type=template&id=ca35b22c"
import script from "./ScheduleFamilyManagementConference.vue?vue&type=script&lang=ts"
export * from "./ScheduleFamilyManagementConference.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports